export default {
  state: {
    user: {},
    menu: [],
    visionShowType: 'five',
  },
  mutations: {
    SET_USER_INFO: (state: any, userinfo: any) => {
      state.user = userinfo;
    },
    SET_MENU_INFO: (state: any, menu: any) => {
      state.menu = menu;
    },
    // 五分法 / 小数记录法的状态
    SET_VISION_SHOW_TYPE: (state: any, visionShowType: any) => {
      state.visionShowType = visionShowType;
    },
  },
  actions: {
  },
  getters: {
  },
};
